__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "custom-quotes-react";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@headlessui/react", "1.7.19", () => (Promise.all([__webpack_require__.e(470), __webpack_require__.e(656), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(9470))))));
			register("@reduxjs/toolkit", "1.9.5", () => (Promise.all([__webpack_require__.e(140), __webpack_require__.e(274)]).then(() => (() => (__webpack_require__(9274))))));
			register("@tbg/collaterate-session-permissions-react", "1.1.0", () => (Promise.all([__webpack_require__.e(656), __webpack_require__.e(561)]).then(() => (() => (__webpack_require__(942))))));
			register("formik", "2.4.2", () => (Promise.all([__webpack_require__.e(595), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(6595))))));
			register("jwt-decode", "4.0.0", () => (__webpack_require__.e(292).then(() => (() => (__webpack_require__(3292))))));
			register("moment", "2.30.1", () => (__webpack_require__.e(944).then(() => (() => (__webpack_require__(5944))))));
			register("react-dom", "18.2.0", () => (Promise.all([__webpack_require__.e(396), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(6396))))));
			register("react-dropzone", "14.2.3", () => (Promise.all([__webpack_require__.e(624), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(6624))))));
			register("react-modal", "3.16.1", () => (Promise.all([__webpack_require__.e(161), __webpack_require__.e(656), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(4161))))));
			register("react-redux", "8.1.2", () => (Promise.all([__webpack_require__.e(894), __webpack_require__.e(656), __webpack_require__.e(686)]).then(() => (() => (__webpack_require__(6894))))));
			register("react-router-dom", "6.13.0", () => (Promise.all([__webpack_require__.e(834), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(4834))))));
			register("react-table", "7.8.0", () => (Promise.all([__webpack_require__.e(492), __webpack_require__.e(656)]).then(() => (() => (__webpack_require__(7492))))));
			register("react", "18.2.0", () => (__webpack_require__.e(565).then(() => (() => (__webpack_require__(7565))))));
			register("yup", "1.3.2", () => (__webpack_require__.e(685).then(() => (() => (__webpack_require__(7685))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};